import { useState } from 'react';
import {
  Box, Divider, Button, Dialog, DialogTitle, DialogContent, IconButton,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import {
  AddPlayer,
  PlayersQueue,
  TopBar,
  PlayersOffline,
  SelectNumberOfPlayersPerTeam,
  CheckoutAllPlayers,
  GenderBalanceToggle,
  SetterBalanceToggle,
  WinPercentageToggle,
  AutoBalanceToggle,
  RemoteControlToggle,
} from 'components';
import {
  removeAllPlayersFromTeams,
  removeAllPlayersFromTeamBoard,
} from 'redux/slices';
import { useDispatch } from 'react-redux';

export function Players({ ranking = false, isAdmin = false }) {
  const dispatch = useDispatch();
  const [settingsOpen, setSettingsOpen] = useState(false);

  const handleRemoveAllPlayersFromTeams = () => {
    dispatch(removeAllPlayersFromTeams());
    dispatch(removeAllPlayersFromTeamBoard());
  };
  return (
    <Box sx={{ bgcolor: '#fdd8e4', minHeight: '100vh' }}>
      <TopBar />
      <Box mt={4} />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
        }}
      >
        <AddPlayer />
        <Button
          variant="outlined"
          startIcon={<SettingsIcon />}
          onClick={() => setSettingsOpen(true)}
        >
          Configurações
        </Button>
      </Box>

      <Dialog open={settingsOpen} onClose={() => setSettingsOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Configurações
          <IconButton onClick={() => setSettingsOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex', flexDirection: 'column', gap: 3, py: 1,
            }}
          >
            <SelectNumberOfPlayersPerTeam />
            <AutoBalanceToggle />
            <GenderBalanceToggle />
            <SetterBalanceToggle />
            <WinPercentageToggle />
            <RemoteControlToggle />
          </Box>
        </DialogContent>
      </Dialog>
      <Box sx={{
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-evenly',
        flexWrap: 'wrap',
        gap: 2,
        mt: 4,
      }}
      >
        {!ranking && !isAdmin && (
          <>
            <Box sx={{ flex: 2 }}>
              <PlayersQueue />
            </Box>
            <Divider orientation="vertical" variant="middle" flexItem />
          </>
        )}
        <Box sx={{ flex: ranking || isAdmin ? 1 : 1 }}>
          <PlayersOffline ranking={ranking} isAdmin={isAdmin} />
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
          my: 4,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            p: 2,
          }}
        >
          <CheckoutAllPlayers />
          <Button sx={{ mt: 2, width: '100%' }} variant="contained" color="secondary" onClick={handleRemoveAllPlayersFromTeams}>Resetar Times</Button>
        </Box>
      </Box>
    </Box>
  );
}
